import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import './styles.css'

class MensajeCanceladoModal extends React.Component {

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                fullWidth={true}
                className='ControlActividadModal'
            >
                <DialogContent className='contenido'>
                    <DialogContentText id="alert-dialog-description">
                        <div style={{marginBottom: '30px'}}>Se canceló tu pedido.</div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions className='botones'>
                        <Button onClick={() => {this.props.handleOnClose(3)}} className="btnPrincipal btnEntendido">
                            ENTENDIDO!
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

MensajeCanceladoModal.propTypes = {
    handleOnClose: PropTypes.func,
    open: PropTypes.object,
}

MensajeCanceladoModal.defaultProps = {
    handleOnClose: f => f
}

export default MensajeCanceladoModal